export const getPayments = (state) => state.payments
export const getPaymentEnums = (state) => state.enums
export const getPaymentStatusEnums = (state) => state.statusEnums